import * as moment from 'moment-timezone';
// Date parser module - defines a single location to perform parsing of datetimes that are returned from the API Layer.
moment.tz.setDefault('America/Los_Angeles');
let userTimeZoneString: string;
/**
 *  Gets the current time of the server
 */
function getServerTime() {
  return moment().tz(getServerTimeZone()); // TODO
}

/**
 * Gets the current server timezone
 * @returns the current server timezone string as defined by moment-timezone
 */
function getServerTimeZone(): string {
  return 'America/Los_Angeles'; // TODO - make this come from configuration value
}

/**
 * gets a list of the names of all available timezones
 * @returns - a string array of available timezones
 */
function getAvailableTimeZones(): string[] {
  return moment.tz.names();
}
/**
 * Guess the user's timezone using the moment.js library function, based on their browser's available data.
 * @returns - a timezone string of the users's most likely current timezone - if not timezone is able to be found, returns the default timezone
 */
function guessUserTimeZone(): string {
  const tz = moment.tz.guess();
  if (moment.tz.zone(tz)) {
    userTimeZoneString = tz;
    return tz;
  }
  return moment.tz().zoneName();
}

/**
 * Get the current user's timezone string - if the user timezone has already been determined or selected, use that value.
 */
function getUserTimeZone(): string {
  return userTimeZoneString || guessUserTimeZone();
}

/**
 * A function that takes a datetime string or object in the server's timezone, and converts it to your local timezone.
 * @param serverDate
 */
function parseServerDateToLocalTime(serverDate: string | Date): moment.Moment {
  return moment.tz(serverDate, getServerTimeZone()).tz(getUserTimeZone());
}

/**
 * Get the current user's current time
 * @returns - a Moment with timezone info related to the user
 */
function now() {
  return moment.tz(getUserTimeZone());
}

/**
 * Compares two moments to each other, and returns the ABSOLUTE difference between the two
 * @returns - a number that is the difference between the two moments provided
 */
function diff(a: moment.Moment, b: moment.Moment, unit: any): number {
  return a.diff(b, unit, true);
}
/**
 * Compares two dates after parsing them into the same time zone to each other,
 *  and returns the ABSOLUTE difference between the two
 * @returns - a number that is the difference between the two dates provided
 */
function diffDate(a: Date, b: Date, unit?: any): number {
  if (!unit) {
    unit = 'days';
  }
  return parseServerDateToLocalTime(a).diff(parseServerDateToLocalTime(b), unit, true);
}

/**
 * returns a string of a date with the time removed
 * @param date
 * @returns - a string formated to "MM/DD/YYYY"
 */
function toDateString(date: Date): string {
  var result = JSON.stringify(date).substring(0, 11);
  return result;
}

export const dateParser = {
  parseDateToLocalTime: parseServerDateToLocalTime,
  getServerTime: getServerTime,
  getAvailableTimeZones: getAvailableTimeZones,
  now: now,
  diff: diff,
  diffDate: diffDate,
  parse: (d: string | Date | moment.Moment) => {
    if (typeof d === 'string') {
      let m: moment.Moment;
      if (d.indexOf('/') === -1) {
        m = moment.tz(d, 'YYYY-MM-DD HH:mm:ss', getUserTimeZone());
        if (!m.isValid()) {
          m = moment.tz(d, 'MM-DD-YYYY', getUserTimeZone());
        }
      } else {
        m = moment.tz(d, 'MM/DD/YYYY', getUserTimeZone());
      }
      if (!m.isValid()) {
        m = moment.tz(d, 'YYYY/MM/DD', getUserTimeZone());
      }
      return m;
    } else {
      return moment.tz(d, getUserTimeZone());
    }
  },
  toDateString: toDateString
};



// WEBPACK FOOTER //
// ./src/common/dateParser.ts